import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const TechnologyShowComponent = (props) => {

  const {t} = props;
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    const technologyId =
      props.technologyId ||
      props.id ||
      window.App.urlVars().technologyId ||
      window.App.urlVars().technology ||
      (entity === 'technology' ? id : null);
    if (technologyId) {
      setLoading(true);
      apiCall('get', '/api/v2/technology/' + technologyId)
        .then(response => {
          setFormData(response.data.data);
          if (props.onLoaded) {
            props.onLoaded(response.data.data || {});
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props.technologyId, props.id, entity, id]);

  return (
    <div className={"technology-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnName')}</label>
            <span className="p-d-block fake-input">
                    {formData.name}
                  </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="active">{t('columnActive')}</label>
            <span className="p-d-block fake-input">
              {formData.active ? props.t('yes') : props.t('no')}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"} id="schedule">
          <div className="p-field p-fluid">
            <label htmlFor="schedule">{t('columnShiftSchedule')}</label>
            <span className={"p-d-block fake-input"}>
              {formData.schedule ? props.t('yes') : props.t('no')}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
export default withTranslation('common')(TechnologyShowComponent);
